














import { Coupon } from '@/resource/coupon/coupon.model';
import {
  checkCoupon,
  createSubscription,
  SubscriptionType,
} from '@/utils/subscription/subscription.util';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { BenefitTextType, PremiumBenefit } from '../PremiumBenefit.vue';
import PremiumCard from '../PremiumCard.vue';

@Component({
  components: { PremiumCard },
})
export default class PremimumCardSix extends Vue {
  @Prop({ default: false })
  showhFreeBenefits!: boolean;

  @Prop({ default: null })
  initCoupon!: string | null;

  benefits: PremiumBenefit[] = [
    {
      isBenfit: true,
      texts: [
        {
          type: BenefitTextType.Normal,
          text: 'Lebih',
        },
        {
          type: BenefitTextType.Highlight,
          text: 'menjimatkan',
        },
      ],
    },
    {
      isBenfit: true,
      texts: [
        {
          type: BenefitTextType.Highlight,
          text: 'Unlimited',
        },
        {
          type: BenefitTextType.Normal,
          text: 'Download PDF Set Latihan',
        },
      ],
    },
    {
      isBenfit: true,
      texts: [
        {
          type: BenefitTextType.Highlight,
          text: 'Unlimited',
        },
        {
          type: BenefitTextType.Normal,
          text: 'Bina Latihan',
        },
      ],
    },
    {
      isBenfit: true,
      texts: [
        {
          type: BenefitTextType.Highlight,
          text: 'Unlimited',
        },
        {
          type: BenefitTextType.Normal,
          text: 'Bank Soalan',
        },
      ],
    },
    {
      isBenfit: true,
      texts: [
        {
          type: BenefitTextType.Highlight,
          text: 'Tiada',
        },
        {
          type: BenefitTextType.Normal,
          text: 'Ads',
        },
      ],
    },
  ];

  priceDiscountlabel = 15;

  selectedCoupon: Coupon | null = null;

  get coupon() {
    const coupon =
      this.$route.query &&
      this.$route.query['coupon'] &&
      (this.$route.query['coupon'] as string);

    const couponAffiliate = this.$route.params.code;

    return coupon || couponAffiliate;
  }

  async created() {
    if (this.coupon || this.initCoupon) {
      let desiredCoupon = '';

      if (this.coupon) {
        desiredCoupon = this.coupon;
      } else if (this.initCoupon) {
        desiredCoupon = this.initCoupon;
      }

      this.selectedCoupon = await checkCoupon({
        coupon: desiredCoupon,
        subscriptionType: SubscriptionType.SixMonth,
      });

      if (this.selectedCoupon) {
        this.priceDiscountlabel = this.selectedCoupon.price;
      }
    }
  }

  updateSelectedCoupon(coupon: Coupon) {
    this.selectedCoupon = coupon;

    if (this.selectedCoupon) {
      this.priceDiscountlabel = this.selectedCoupon.price;
    }
  }

  async onSubscriptionSubmit() {
    this.$sendMpEvent({ event: this.$mp_value.SubscriptionSixMonthClick });

    const checkoutUrl = await createSubscription({
      subscriptionType: SubscriptionType.SixMonth,
      coupon: this.selectedCoupon ? this.selectedCoupon.name : '',
    });

    if (checkoutUrl) {
      return window.location.assign(checkoutUrl);
    } else {
      this.$toasted.global.mainToast({
        message: 'Something is wrong, please contact us at hello@mysoalan.com',
      });
    }
  }
}
